module.exports = __webpack_public_path__ + "img/chinesecompany96.c9c54ad1.png";